import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { IIndividualCustomer } from '../models/customer.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Get an individual Customer and Card Group information
 * 
 * @returns {object} the api response
 */
const GetCustomerIndividual = async ( customerId: string ): Promise<IIndividualCustomer> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get(`/customer/${customerId}`, {
      params: {
        wpID: userId
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting user data');
    throw(error);
  }
}

export default GetCustomerIndividual;